import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {MainMenuEnum} from '../Enums/Enums';

class MainMenu extends React.Component {
  state = {
    value: 1,
  };

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.data.Main.OpenMainView(value);
  };

  render() {
    const { value } = this.state;
    return (
        <div style={{backgroundColor:"Black",color:"White"}}>
            <Tabs value={value} onChange={this.handleChange.bind(this)}>
              <Tab style={{minWidth:"100px"}} label="HOME"   value={MainMenuEnum.Home} />
              <Tab style={{minWidth:"100px"}} label="APX"  value={MainMenuEnum.Apx} />
              <Tab style={{minWidth:"100px"}} label="AMICUS CLOUD"  value={MainMenuEnum.AmicusOnline} />
              <Tab style={{minWidth:"100px"}} label="OFFICETOOLS CLOUD"  value={MainMenuEnum.OfficeTools} />
            </Tabs>
        </div>
    );
  }
}

export default MainMenu;